module.exports = `${require.publicPath}NotoSansSC-Regular.5107c334.woff`;